import { useMemo } from 'react';
import { useBuildVars } from '../build-config';
import { useSearchParams } from 'react-router-dom';

export enum IM360Regions {
  AMER = 'AMER',
  ANZ = 'ANZ',
  APAC = 'APAC',
  EMEA = 'EMEA',
}

const useIM360Origin = () => {
  const {
    IM360_ORIGIN_AMER,
    IM360_ORIGIN_ANZ,
    IM360_ORIGIN_APAC,
    IM360_ORIGIN_EMEA,
  } = useBuildVars();

  const [queryParams] = useSearchParams();
  const im360Region = queryParams.get('region');

  const IM360_ORIGIN = useMemo(() => {
    switch (im360Region) {
      case IM360Regions.AMER:
        return IM360_ORIGIN_AMER;
      case IM360Regions.EMEA:
        return IM360_ORIGIN_EMEA;
      case IM360Regions.APAC:
        return IM360_ORIGIN_APAC;
      case IM360Regions.ANZ:
        return IM360_ORIGIN_ANZ;
      default:
        return IM360_ORIGIN_EMEA;
    }
  }, [
    im360Region,
    IM360_ORIGIN_AMER,
    IM360_ORIGIN_EMEA,
    IM360_ORIGIN_APAC,
    IM360_ORIGIN_ANZ,
  ]);

  return IM360_ORIGIN;
};

export default useIM360Origin;
